import { useState, useEffect } from 'react';
import SocketClient from 'utils/socket';

const useSocket = () => {
  const [socket, setSocket] = useState(SocketClient.socket);
  const [isConnected, setIsConnected] = useState(SocketClient.socket?.connected || false);

  useEffect(() => {
    const currentSocket = SocketClient.socket;

    if (currentSocket) {
      setSocket(currentSocket);
      setIsConnected(currentSocket.connected);

      // Listen for connect/disconnect to update state
      const handleConnect = () => {
        setIsConnected(true);
      };

      const handleDisconnect = () => {
        setIsConnected(false);
      };

      currentSocket.on('connect', handleConnect);
      currentSocket.on('disconnect', handleDisconnect);

      return () => {
        currentSocket.off('connect', handleConnect);
        currentSocket.off('disconnect', handleDisconnect);
      };
    }

    // Subscribe to socket changes (new socket created)
    const unsubscribe = SocketClient.subscribe((newSocket) => {
      setSocket(newSocket);
      setIsConnected(newSocket?.connected || false);
    });

    return unsubscribe;
  }, []);

  return { socket, isConnected };
};

export default useSocket;
